import React from 'react';
import { StatusBadge as CommonStatusBadge } from '../../ui/common';

interface StatusBadgeProps {
  status?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return <CommonStatusBadge status={status} variant="admin" />;
};

export default StatusBadge;
